import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import type { StudyFilterItem } from '../StudyFilterDropdown/types';
import type { StudyFilterDropdownProps } from '~/Blocks/StudyFilterSectionBlock/View/Components/StudyFilterDropdown/StudyFilterDropdown';
import { StudyFilterDropdown } from '~/Blocks/StudyFilterSectionBlock/View/Components/StudyFilterDropdown/StudyFilterDropdown';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { asHtmlString } from '~/Partials/Controls/Utils/asHtmlString';
import type { WithId } from '~/Partials/Utils/typeUtils';
import styles from './InteractiveFilters.module.css';
import type { InteractiveFiltersVariant } from './InteractiveFiltersVariant';

export type DropdownElement = WithId<Pick<StudyFilterDropdownProps, 'items' | 'selectLabel' | 'placeholder'>>;

export type InteractiveFilterElement = string | DropdownElement;

export type SelectedOptionsMap = Record<string, StudyFilterItem[]>;

export interface InteractiveFiltersProps {
    elements: InteractiveFilterElement[];
    selectedOptions: SelectedOptionsMap;
    onSelect: (id: string, items: StudyFilterItem[]) => void;
    variant?: InteractiveFiltersVariant;
}

export const InteractiveFilters: React.FC<React.PropsWithChildren<InteractiveFiltersProps>> = props => {
    const { elements, onSelect, selectedOptions, variant = 'light' } = props;

    const studyFilterDropdownVariant = variant === 'light' ? 'dark' : 'light';

    return (
        <div className={classNames(styles.InteractiveFilters, styles[`Variant--${variant}`])}>
            {elements.map(element => {
                if (typeof element === 'string') {
                    return (
                        <HtmlDiv
                            key={uniqueId('textFragment_')}
                            className={styles.TextFragment}
                            html={asHtmlString(element)}
                        />
                    );
                } else {
                    return (
                        <StudyFilterDropdown
                            key={element.id}
                            {...element}
                            selectedItems={selectedOptions[element.id] ?? []}
                            onSelectionChanged={option => onSelect(element.id, option)}
                            variant={studyFilterDropdownVariant}
                        />
                    );
                }
            })}
        </div>
    );
};
